<template>
  <div class="topbar-item">
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn btn-secondary side-panel-btn"
        @click="toggleNotificacoes"
      >
        <Toast position="top-center" group="notif" />
        <div class="notification-bell-container">
          <div
            class="notification-backdrop"
            :class="{ 'd-none': !is_notification_body_open }"
          ></div>
          <div class="notification-bell-ball">
            <i
              style="color: white; padding-right: 0px"
              class="fa-solid fa-bell"
              :class="{ 'notification-unread': unreadNotifications.length > 0 }"
            ></i>
            <div
              class="new-notification-news-ball"
              v-if="unreadNotifications.length > 0"
            >
              <span>{{ unreadNotifications.length }}</span>
            </div>
          </div>
          <div
            class="notification-body-container"
            v-if="is_notification_body_open"
          >
            <div v-if="notificacoes_iniciais.length == 0">
              <div class="notification-body-item">
                <div class="notification-body-item-title">
                  Nenhuma notificação
                </div>
                <div class="notification-body-item-description">
                  Você não possui nenhuma notificação.
                </div>
              </div>
            </div>
            <div
              class="notification-body-item"
              v-for="notificacao in notificacoes_iniciais"
              :key="'notif-' + notificacao.novidade_id"
              :class="{
                'notification-unread': !notificacao.nus_visualizado
              }"
              @click="() => clickNotificacao(notificacao)"
            >
              <div class="notification-body-item-title" v-blur-sensitive>
                {{ notificacao.nov_titulo }}
              </div>
              <div class="notification-body-item-description" v-blur-sensitive>
                {{ notificacao.nov_descricao }}
              </div>
              <div class="notification-body-item-date">
                {{ parseDataFormatoBrasileiro(notificacao.created_at) }}
              </div>
              <div
                class="unread-notification-ball"
                v-if="!notificacao.nus_visualizado"
              ></div>
            </div>
          </div>
        </div>
      </button>
      <button
        id="kt_profile_toggle"
        type="button"
        class="btn btn-secondary side-panel-btn"
      >
        <i
          class="fas icon-lg text-white fa-user"
          style="padding-right: 0px"
        ></i>
      </button>
      <button
        id="kt_quick_user_toggle"
        type="button"
        class="btn btn-secondary"
        v-bind:class="{
          'side-panel-btn': !contas[0].validacaoChat && contas[0].cca_ativo,
          'side-panel-btn-fail': contas[0].validacaoChat || !contas[0].cca_ativo
        }"
      >
        <i
          class="fas icon-lg text-white"
          v-bind:class="{
            'fa-comment': !contas[0].validacaoChat && contas[0].cca_ativo,
            'fa-comment-slash': contas[0].validacaoChat || !contas[0].cca_ativo
          }"
          style="padding-right: 0px"
        ></i>
      </button>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-5"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between"
      >
        <h4 class="font-weight-bold m-0">Conexão ao WhatsApp</h4>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>

      <b-overlay :show="loadingInfo" rounded="sm" class="mt-2">
        <template #overlay>
          <v-progress-circular indeterminate size="44" color="#462181"
            ><v-progress-circular
              indeterminate
              size="28"
              color="#ff7f00"
              rotate="180"
            ></v-progress-circular
          ></v-progress-circular>
        </template>
        <perfect-scrollbar
          class="offcanvas-content pr-5 mr-n5 scroll"
          style="max-height: 90vh; position: relative"
        >
          <div class="separator separator-dashed mt-8 mb-3"></div>
          <!-- <div class="d-flex mt-1" v-if="isAdmin">
          <button
            class="btn btn-danger btn-bold flex-fill ml-2"
            @click="onBroadCast"
          >
            BroadCast Whatsapp Desconectado
          </button>
        </div> -->

          <div class="navi navi-spacer-x-0 p-0" v-if="exibirCanais">
            <div
              class="navi-item"
              v-for="(conta, index) in contas"
              :key="index"
            >
              <modal-enviar-manual
                :ref="`modalEnviarManual${index}`"
                :conta="conta"
                :mostrarBotao="false"
              >
              </modal-enviar-manual>
              <p class="mb-0">
                <span
                  v-b-tooltip.html="
                    `<b>Código da conta:</b> ${conta.id}${
                      conta.nomeIdentificacao
                        ? `<br><b>Nome:</b> ${conta.nomeIdentificacao}`
                        : ''
                    }`
                  "
                >
                  <b>Conta:</b>
                  <span v-blur-sensitive>
                    {{ conta.login }}
                  </span>
                </span>
                <img
                  v-if="conta.whatsappOficial"
                  :src="'/media/comunicante/meta-logo.png'"
                  style="width: 16px"
                />
              </p>
              <div class="navi-link pt-0">
                <div class="symbol symbol-50 bg-light mr-3 border">
                  <img
                    v-blur-sensitive
                    :src="
                      conta.picture
                        ? conta.picture
                        : '/media/comunicante/logo-whats-cinza.png'
                    "
                  />
                </div>
                <div class="navi-text">
                  <template v-if="!conta.validacaoChat">
                    <div class="d-flex justify-content-between">
                      <div>
                        <div class="font-weight-bold" v-blur-sensitive>
                          {{ conta.pushname }}
                        </div>
                        <div class="text-muted" v-blur-sensitive>
                          {{ conta.phone }}
                        </div>
                      </div>
                      <div class="d-flex" style="gap: 0.5rem">
                        <template v-if="conta.whatsappOficial">
                          <modal-configuracoes-whatsapp-oficial
                            :conta="conta"
                          ></modal-configuracoes-whatsapp-oficial>
                        </template>
                        <template v-else>
                          <button
                            class="btn btn-icon btn-light-success mr-1"
                            :class="{
                              'btn-light-success': conta.esquenta_chip_ativo,
                              'btn-light-danger': !conta.esquenta_chip_ativo
                            }"
                            type="button"
                            v-b-tooltip.noninteractive.hover.left
                            :title="
                              'Wellon Booster ' +
                              (conta.esquenta_chip_ativo ? 'Ativo' : 'Inativo')
                            "
                            @click="toggleEsquentaChip(index, conta)"
                          >
                            <i
                              class="fa-solid fa-bolt"
                              :style="{
                                color: conta.esquenta_chip_ativo
                                  ? '#ffa800'
                                  : '#b0b3b6'
                              }"
                            ></i>
                          </button>
                        </template>

                        <button
                          class="btn btn-icon btn-light-primary mr-1"
                          type="button"
                          v-b-tooltip.noninteractive.hover.left
                          title="Copiar Link"
                          @click="
                            copiarLinkApi(index, conta.login, conta.senha)
                          "
                          :id="`btnCopiarLinkApi${index}`"
                        >
                          <i class="fas fa-link"></i>

                          <b-tooltip
                            :ref="`tooltipCopiarLinkApi${index}`"
                            :target="`btnCopiarLinkApi${index}`"
                            disabled
                          >
                            Copiado!
                          </b-tooltip>
                        </button>

                        <button
                          v-if="!conta.whatsappOficial"
                          class="btn btn-icon btn-light-info"
                          type="button"
                          v-b-tooltip.noninteractive.hover.left
                          title="Reiniciar"
                          @click.prevent="reiniciarWhatsapp(conta)"
                        >
                          <i class="flaticon2-reload"></i>
                        </button>
                      </div>
                    </div>
                  </template>

                  <template v-if="conta.validacaoChat">
                    <modal-qrCode
                      :conta="conta"
                      tipoBotao="botao"
                      textoBotao="Clique aqui para conectar!"
                      variant="info"
                      :gestorCanais="true"
                    ></modal-qrCode>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </b-overlay>
    </div>

    <div
      id="kt_profile"
      ref="kt_profile"
      class="offcanvas offcanvas-right profile-panel"
    >
      <!--begin::Header-->
      <div class="offcanvas-header profile-panel__header">
        <h4 class="profile-panel__title">Perfil</h4>
        <a href="#" class="profile-panel__close" id="kt_profile_close">
          <i class="ki ki-close"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content profile-panel__body scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Hero-->
        <div class="profile-hero">
          <div class="profile-hero__avatar" v-blur-sensitive>
            {{ userInitials }}
          </div>
          <div class="profile-hero__info">
            <span class="profile-hero__name" v-blur-sensitive>
              {{ currentUserPersonalInfo.nome }}
            </span>
            <span v-if="userRole" class="profile-hero__role">
              <i class="fas fa-shield-alt mr-1"></i>{{ userRole }}
            </span>
            <span class="profile-hero__email" v-blur-sensitive>
              {{ userEmail }}
            </span>
          </div>
        </div>
        <!--end::Hero-->

        <!--begin::Dados do usuário-->
        <div class="profile-card">
          <h5 class="profile-card__title">
            <i class="fas fa-user"></i> Dados do usuário
          </h5>

          <b-form class="form" novalidate="novalidate" ref="frmPerfil">
            <b-form-group class="profile-field mb-4">
              <label class="profile-field__label">
                Nome <span class="text-danger">*</span>
              </label>
              <b-form-input
                v-blur-sensitive
                class="profile-input"
                v-model="frmPerfil.nome"
                name="nome"
                ref="nome"
              ></b-form-input>
            </b-form-group>

            <b-form-group class="profile-field mb-0">
              <label class="profile-field__label">
                Celular <span class="text-danger">*</span>
              </label>
              <b-form-input
                v-blur-sensitive
                class="profile-input"
                v-model="frmPerfil.celular"
                name="celular"
                ref="celular"
                data-inputmask="'mask': ['(99) 9999-9999', '(99) 99999-9999'], 'placeholder': ''"
              ></b-form-input>
            </b-form-group>
          </b-form>
        </div>
        <!--end::Dados do usuário-->

        <!--begin::Segurança-->
        <div class="profile-card">
          <h5 class="profile-card__title">
            <i class="fas fa-lock"></i> Segurança
          </h5>

          <div class="profile-toggle">
            <span class="profile-toggle__label">
              Autenticação de dois fatores
            </span>
            <InputSwitch
              v-model="frmPerfil.habilitar2FA"
              :disabled="checkSuperAdmin || isAccountAdmin"
            ></InputSwitch>
          </div>

          <div v-if="frmPerfil.habilitar2FA" class="auth-2fa">
            <span class="profile-field__label d-block mb-2">
              Método de autenticação
            </span>

            <!-- Aplicativo autenticador (recomendado) + QR/estado no mesmo bloco -->
            <div class="auth-method-block">
              <div
                class="auth-method"
                :class="{ 'auth-method--active': frmPerfil.canal2FA === 'app' }"
                @click="selecionarCanal('app')"
              >
                <span class="auth-method__radio"></span>
                <div class="auth-method__icon">
                  <i class="fas fa-mobile-alt"></i>
                </div>
                <div class="auth-method__text">
                  <div class="auth-method__title">
                    Aplicativo autenticador
                    <span class="auth-method__badge">Recomendado</span>
                  </div>
                  <div class="auth-method__desc">
                    Use um app autenticador como Google Authenticator, Authy ou
                    Similar.
                  </div>
                </div>
              </div>

              <!-- Estado do canal por aplicativo (QR / ativo) logo abaixo -->
              <div v-if="frmPerfil.canal2FA === 'app'" class="auth-panel">
                <div v-if="qr2fa.confirmado" class="auth-status">
                  <i class="fas fa-check-circle auth-status__icon"></i>
                  <div class="auth-status__body">
                    <div class="auth-status__title">
                      Aplicativo autenticador ativo
                    </div>
                    <div class="auth-status__desc">
                      Use o código gerado no app para acessar sua conta.
                    </div>
                    <a
                      href="#"
                      class="auth-status__action"
                      @click.prevent="trocarDispositivoApp"
                    >
                      Trocar dispositivo
                      <i class="fas fa-chevron-right ml-1"></i>
                    </a>
                  </div>
                </div>

                <div v-else class="auth-qr">
                  <p class="auth-qr__hint">
                    Escaneie o QR abaixo com seu aplicativo autenticador e
                    informe o código de 6 dígitos gerado para confirmar.
                  </p>

                  <div
                    v-if="qr2fa.carregando"
                    class="text-center text-muted py-3"
                  >
                    Gerando QR...
                  </div>

                  <div v-else-if="qr2fa.svg" class="text-center">
                    <div
                      class="auth-qr__code d-inline-block"
                      v-html="qr2fa.svg"
                    ></div>

                    <b-input-group class="mt-2">
                      <b-form-input
                        class="profile-input"
                        v-model="qr2fa.codigo"
                        placeholder="Código de 6 dígitos"
                        maxlength="6"
                        inputmode="numeric"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          variant="primary"
                          :disabled="qr2fa.confirmando"
                          @click="confirmarApp"
                        >
                          Confirmar
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </div>
              </div>
            </div>

            <!-- Código por mensagem (secundário) -->
            <div
              class="auth-method"
              :class="{
                'auth-method--active': frmPerfil.canal2FA === 'celular'
              }"
              @click="selecionarCanal('celular')"
            >
              <span class="auth-method__radio"></span>
              <div class="auth-method__icon">
                <i class="fas fa-comment-dots"></i>
              </div>
              <div class="auth-method__text">
                <div class="auth-method__title">Código por mensagem</div>
                <div class="auth-method__desc">
                  Receba um código de verificação por SMS no seu celular. Se não
                  houver celular cadastrado, o código é enviado por e-mail.
                </div>
              </div>
            </div>
          </div>

          <p class="profile-hint mt-3">
            * Campos obrigatórios para administradores
          </p>
        </div>
        <!--end::Segurança-->

        <!--begin::Footer-->
        <div class="profile-panel__footer">
          <b-button class="profile-btn-primary" block @click="salvar">
            <i class="fas fa-lock mr-2"></i> Salvar alterações
          </b-button>

          <div class="profile-btn-secondary-wrap">
            <modal-alterar-senha
              url="usuario/alterar-senha"
              titulo="Alterar Senha do Usuário"
              :exigirSenhaAtual="true"
              tipoBotao="botao"
              :botaoAcoes="false"
              variant="light"
            ></modal-alterar-senha>
          </div>
        </div>
        <!--end::Footer-->
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
#kt_profile {
  overflow: hidden;
}
.navi .navi-item .navi-link:hover .navi-text {
  color: #3f4254 !important;
}

/* ===== Painel de Perfil (QuickUser) — redesign Wellon =====
   Tudo aninhado sob .profile-panel para namespacing forte: mesmo os
   ::v-deep (InputSwitch/BootstrapVue/QR) ficam presos a
   .profile-panel[data-v] ..., sem alcançar outras telas. */
$wellon-purple: #472282;
$wellon-purple-dark: #3b1d6b;
// Tom mais claro/vibrante para o botão de salvar (o #472282 lia como quase preto).
$wellon-purple-btn: #5a34a5;
$ink: #1a1a2e;
$muted: #6b7280;
$line: #eef0f4;

.profile-panel {
  display: flex;
  flex-direction: column;
  background: #fff;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid $line;
    flex: 0 0 auto;
  }

  &__title {
    margin: 0;
    font-size: 1.35rem;
    font-weight: 700;
    color: $ink;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: 1px solid $line;
    color: $muted;
    transition: all 0.2s ease;

    &:hover {
      background: #f5f6fa;
      color: $ink;
    }

    i {
      font-size: 0.85rem;
    }
  }

  &__body {
    padding: 16px 24px 0;
    position: relative;
  }

  &__footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 16px 0 22px;
    margin-top: 4px;
    border-top: 1px solid $line;
  }

  .profile-hero {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 2px 0 14px;

    &__avatar {
      flex: 0 0 auto;
      width: 72px;
      height: 72px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.6rem;
      font-weight: 700;
      letter-spacing: 1px;
      color: $wellon-purple;
      background: linear-gradient(135deg, #ede8f7 0%, #d9cdf0 100%);
      border: 2px solid #e2d8f5;
    }

    &__info {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    &__name {
      font-size: 1.15rem;
      font-weight: 700;
      color: $ink;
      line-height: 1.3;
    }

    &__role {
      align-self: flex-start;
      margin: 5px 0;
      padding: 3px 10px;
      font-size: 0.76rem;
      font-weight: 600;
      color: $wellon-purple;
      background: #ede8f7;
      border-radius: 20px;

      i {
        font-size: 0.7rem;
      }
    }

    &__email {
      font-size: 0.85rem;
      color: $muted;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .profile-card {
    background: #fff;
    border: 1px solid $line;
    border-radius: 14px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04);

    &__title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
      font-size: 0.95rem;
      font-weight: 700;
      color: $ink;

      i {
        color: $wellon-purple;
        font-size: 0.95rem;
      }
    }
  }

  .profile-field {
    &__label {
      display: block;
      margin-bottom: 6px;
      font-size: 0.82rem;
      font-weight: 600;
      color: #4b5563;
    }
  }

  ::v-deep .profile-input {
    height: 44px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 0 14px;
    font-size: 0.92rem;
    color: $ink;
    box-shadow: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: $wellon-purple;
      box-shadow: 0 0 0 3px rgba(71, 34, 130, 0.12);
    }
  }

  .profile-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__label {
      font-size: 0.9rem;
      font-weight: 600;
      color: $ink;
    }
  }

  .auth-2fa {
    margin-top: 14px;
  }

  .auth-method-block {
    margin-bottom: 8px;
  }

  .auth-method {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    margin-bottom: 8px;
    border: 1.5px solid #e5e7eb;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      border-color: #cbb9ea;
    }

    &--active {
      border-color: $wellon-purple;
      background: #faf8fd;
    }

    // O bloco do app já controla o espaçamento; o card interno não repete margem.
    .auth-method-block & {
      margin-bottom: 0;
    }

    &__radio {
      flex: 0 0 auto;
      width: 18px;
      height: 18px;
      margin-top: 2px;
      border-radius: 50%;
      border: 2px solid #cbd0d9;
      background: #fff;
      position: relative;
      transition: all 0.15s ease;

      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: $wellon-purple;
        transform: translate(-50%, -50%) scale(0);
        transition: transform 0.15s ease;
      }
    }

    &--active &__radio {
      border-color: $wellon-purple;

      &::after {
        transform: translate(-50%, -50%) scale(1);
      }
    }

    &__icon {
      flex: 0 0 auto;
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f3eefb;
      color: $wellon-purple;
      font-size: 1.05rem;
    }

    &--active &__icon {
      background: #ede4fa;
    }

    &__text {
      min-width: 0;
    }

    &__title {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px;
      margin-bottom: 2px;
      font-size: 0.9rem;
      font-weight: 700;
      color: $ink;
    }

    &--active &__title {
      color: $wellon-purple;
    }

    &__badge {
      font-size: 0.68rem;
      font-weight: 600;
      color: $wellon-purple;
      background: #ede8f7;
      padding: 2px 8px;
      border-radius: 20px;
    }

    &__desc {
      font-size: 0.8rem;
      line-height: 1.35;
      color: $muted;
    }
  }

  .auth-status {
    display: flex;
    gap: 12px;
    padding: 14px;
    border: 1px solid #b7ebc9;
    background: #eefbf3;
    border-radius: 12px;

    &__icon {
      color: #1bab5b;
      font-size: 1.2rem;
      margin-top: 1px;
    }

    &__title {
      font-size: 0.88rem;
      font-weight: 700;
      color: #157a43;
    }

    &__desc {
      margin: 2px 0 6px;
      font-size: 0.8rem;
      color: #4b5563;
    }

    &__action {
      font-size: 0.82rem;
      font-weight: 600;
      color: $wellon-purple;

      &:hover {
        color: $wellon-purple-dark;
      }

      i {
        font-size: 0.66rem;
      }
    }
  }

  // Estado do canal por app (QR/ativo) — logo abaixo do card do app, mesmo bloco.
  .auth-panel {
    margin: 8px 0 4px;
  }

  .auth-qr {
    &__hint {
      margin-bottom: 10px;
      font-size: 0.82rem;
      line-height: 1.35;
      color: $muted;
    }

    &__code {
      padding: 8px;
      background: #fff;
      border: 1px solid $line;
      border-radius: 10px;
      max-width: 180px;

      ::v-deep svg {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .profile-hint {
    margin: 0;
    font-size: 0.78rem;
    color: #9aa1ac;
  }

  ::v-deep .profile-btn-primary {
    height: 48px;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 600;
    background: $wellon-purple-btn;
    border-color: $wellon-purple-btn;

    &:hover,
    &:active {
      background: $wellon-purple !important;
      border-color: $wellon-purple !important;
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(90, 52, 165, 0.25) !important;
    }
  }

  .profile-btn-secondary-wrap {
    margin-top: 10px;

    ::v-deep .btn {
      height: 48px;
      border-radius: 12px;
      font-size: 0.95rem;
      font-weight: 600;
      background: #fff;
      border: 1px solid #e5e7eb;
      color: $ink;
      box-shadow: none;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover,
      &:focus {
        background: #f7f8fb;
        border-color: #d5d9e0;
        color: $ink;
      }
    }
  }

  ::v-deep .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
    background: $wellon-purple;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTLayoutQuickProfile from "@/assets/js/layout/extended/quick-profile.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import Swal from "sweetalert2";

import ApiService from "@/core/services/api.service";
import moment from "moment";
import API_LINKS from "../../../pages/painel/automacao/api.links";
import Toast from "primevue/toast";

import ModalConfiguracoesWhatsappOficial from "./ModalConfiguracoesWhatsappOficial";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import InputSwitch from "primevue/inputswitch";
import Inputmask from "inputmask";
import ModalAlterarSenha from "@/view/components/ModalAlterarSenha";

import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import ModalEnviarManual from "@/view/pages/painel/conta/ModalEnviarManual";

export default {
  name: "KTQuickUser",
  data() {
    return {
      shortPollingNotificationIntervalMS: 15000,
      stillRequestingNotifications: false,
      frmAlterarSenha: {
        senhaAtual: "",
        novaSenha: "",
        alterarNovaSenha: ""
      },
      contas: [{ validacaoChat: true, cca_ativo: false }],
      timeout: null,
      exibirConexaoContas: true,
      conta_just_added_today: false,
      is_notification_body_open: false,
      notificacoes_iniciais: [],
      notifications_interval: null,
      frmPerfil: {
        email: "",
        nome: "",
        celular: "",
        habilitar2FA: false,
        canal2FA: "celular"
      },
      qr2fa: {
        svg: "",
        codigo: "",
        carregando: false,
        confirmando: false,
        confirmado: false
      },
      loadingInfo: false
    };
  },

  components: {
    Toast,
    "modal-configuracoes-whatsapp-oficial": ModalConfiguracoesWhatsappOficial,
    InputSwitch,
    "modal-alterar-senha": ModalAlterarSenha,
    ModalEnviarManual
  },

  mounted() {
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    KTLayoutQuickProfile.init(this.$refs["kt_profile"]);

    const self = this;
    this.$bus.$on("logout:usuario", function () {
      self.onLogout();
    });
    this.notificationsShortPolling();
    this.abrir();
    this.validacao();
  },
  beforeDestroy() {
    clearInterval(this.notifications_interval);
    this.limpar();
  },
  computed: {
    ...mapGetters([
      "currentUserPersonalInfo",
      "isAdmin",
      "hasPermission",
      "validatorErrors",
      "checkSuperAdmin",
      "isAccountAdmin"
    ]),
    userInitials() {
      const nome = (this.currentUserPersonalInfo.nome || "").trim();
      if (!nome) return "?";
      const partes = nome.split(/\s+/).filter(Boolean);
      if (partes.length === 1) {
        return partes[0].substring(0, 2).toUpperCase();
      }
      return (
        partes[0].charAt(0) + partes[partes.length - 1].charAt(0)
      ).toUpperCase();
    },
    userRole() {
      const role = this.currentUserPersonalInfo.role;
      return role && role.description ? role.description : "";
    },
    userEmail() {
      return this.currentUserPersonalInfo.login;
    },
    exibirCanais() {
      if (!this.isAdmin && this.hasPermission("conectar-aparelho")) {
        if (this.exibirConexaoContas) {
          this.inicializar();
          this.desativarConexaoContas();
        }
        return true;
      }
      return false;
    },
    unreadNotifications() {
      return this.notificacoes_iniciais.filter(
        (notificacao) => !notificacao.nus_visualizado
      );
    }
  },

  methods: {
    inicializar() {
      this.loadingInfo = true;
      ApiService.post(
        "/dashboard/info",
        {
          idConta: null,
          exibirSubcontas: true
        },
        false,
        false
      )
        .then((response) => {
          const contas = response.data.data.map((conta) => {
            if (conta.data_primeira_ativacao && !conta.whatsappOficial) {
              const ativacao = moment(
                conta.data_primeira_ativacao,
                "YYYY-MM-DD HH:mm:ss"
              );
              const today = moment();
              const seven_days_ago = moment().subtract(7, "day");
              const dont_show_booster =
                localStorage.getItem("dont_show_booster");
              const flag_mostrar_booster = dont_show_booster
                ? moment(dont_show_booster, "YYYY-MM-DD") <= today
                : true;

              if (flag_mostrar_booster && ativacao > seven_days_ago) {
                Swal.fire({
                  title: "Atenção!",
                  text: "Você tem um número que foi ativo recentemente, você pode ativar o Wellon Booster para ele, para isso, basta clicar no botão de Conexões de Whatsapp.",
                  icon: "warning",
                  confirmButtonText: "Ok",
                  cancelButtonText: "Não exibir novamente",
                  showCancelButton: true,
                  buttonsStyling: true
                }).then((result) => {
                  if (result.dismiss) {
                    localStorage.setItem(
                      "dont_show_booster",
                      moment().add(1, "day").format("YYYY-MM-DD")
                    );
                  }
                });
              }
            }
            return conta;
          });
          if (contas.length > 0) {
            this.contas = contas;
          }
        })
        .finally(() => {
          this.loadingInfo = false;
        });
    },
    onBroadCast() {
      Swal.fire({
        title: "Deseja realmente usar o Botão de BroadCast?",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-danger"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.post(
            "/administrativo/broadcast-connection-closed",
            {},
            false
          ).then((response) => {});
        }
      });
    },
    onLogout() {
      Swal.fire({
        title: "Deseja realmente sair?",
        showCancelButton: true,
        confirmButtonText: "Sair",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-danger"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          if (window.$chatwoot) {
            window.$chatwoot.toggleBubbleVisibility("hide");
          }
          this.$store.dispatch(LOGOUT, true).then(() => {
            this.$router.push({ name: "login" });
          });
        }
      });
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
      new KTOffcanvas(KTLayoutQuickProfile.getElement()).hide();
    },
    mudarVisibilidade(id, e) {
      const campo = document.getElementById(id);
      const icone = e.currentTarget.firstChild;

      if (campo.getAttribute("type") === "password") {
        campo.setAttribute("type", "text");
        icone.classList.add("fa-eye-slash");
        icone.classList.remove("fa-eye");
      } else {
        campo.setAttribute("type", "password");
        icone.classList.add("fa-eye");
        icone.classList.remove("fa-eye-slash");
      }
    },
    usarSenha(senha) {
      this.frmAlterarSenha.novaSenha = senha;
      this.frmAlterarSenha.confirmarNovaSenha = senha;
    },
    reiniciarWhatsapp(conta) {
      const payload = {
        conta_id: conta.id
      };
      Swal.fire({
        title: "Deseja realmente reiniciar o Whatsapp?",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.reiniciarWhatsappConfirmado(payload);
        }
      });
    },
    reiniciarWhatsappConfirmado(payload) {
      ApiService.post("/conta/reiniciar-whatsapp", payload)
        .then(() => {
          Swal.fire({
            title: "Sucesso!",
            text: "O Whatsapp foi reiniciado com sucesso!",
            icon: "success",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary"
            },
            buttonsStyling: false
          });
        })
        .catch((error) => {
          Swal.fire({
            title: "Erro!",
            text: "O Whatsapp não foi reiniciado!",
            icon: "error",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary"
            },
            buttonsStyling: false
          });
        });
    },
    desativarConexaoContas() {
      this.exibirConexaoContas = false;
    },
    copiarLinkApi(index, login, senha) {
      const api = process.env.VUE_APP_COMUNICANTE_API;
      const link = `${api}/v1/sms/envio?usuario=${login}&senha=${senha}`;
      const tooltip = `tooltipCopiarLinkApi${index}`;

      navigator.clipboard.writeText(link).then(() => {
        this.$refs[tooltip][0].$emit("open");
        setTimeout(() => {
          this.$refs[tooltip][0].$emit("close");
        }, 1000);
      });

      this.abrirModalManual(index);
    },
    abrirModalManual(index) {
      this.$refs[`modalEnviarManual${index}`][0].abrir();
    },
    toggleEsquentaChip(index, conta) {
      const esquenta_chip_ativo = conta.esquenta_chip_ativo;
      Swal.fire({
        title: esquenta_chip_ativo
          ? "Desativar Wellon Booster"
          : "Ativar Wellon Booster",
        text: `Deseja realmente ${
          conta.esquenta_chip_ativo ? "desativar" : "ativar"
        } o Wellon Booster para o número ${conta.phone}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-success"
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          ApiService.post(
            "/configuracao/toggle-esquenta-chip",
            {
              conta_id: conta.id,
              numero_linha: conta.phone
            },
            false
          ).then((response) => {
            this.contas[index].esquenta_chip_ativo =
              response.data.data.esquenta_chip_ativo == "S";
            Swal.fire({
              title: "Sucesso!",
              text: `Wellon Booster ${
                esquenta_chip_ativo ? "desativado" : "ativado"
              } com sucesso!`,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          });
        }
      });
    },
    toggleNotificacoes() {
      this.is_notification_body_open = !this.is_notification_body_open;
    },
    async pegarNotificacoes() {
      try {
        if (this.stillRequestingNotifications) return;
        this.stillRequestingNotifications = true;
        const res = await ApiService.get(
          API_LINKS.novidades + "/usuario",
          "",
          false
        );
        this.stillRequestingNotifications = false;
        res.data.novidades.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        if (
          this.notificacoes_iniciais.length > 0 &&
          this.notificacoes_iniciais.length < res.data.novidades.length
        ) {
          const latest_notification = res.data.novidades[0];
          this.$toast.add({
            severity: "info",
            summary: latest_notification.nov_titulo,
            detail: latest_notification.nov_descricao,
            closable: false,
            life: 5000,
            group: "notif",
            icon: "pi pi-bell"
          });
        }
        this.notificacoes_iniciais = res.data.novidades;
      } catch (error) {
        clearInterval(this.notifications_interval);
      }
    },
    parseDataFormatoBrasileiro(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
    clickNotificacao(notificacao) {
      this.toggleNotificacoes();
      if ("redirecionar" in notificacao && !notificacao.redirecionar) {
        return;
      }
      this.$router.push({
        name: "novidade.nova",
        params: {
          id: notificacao.novidade_id
        }
      });
    },
    notificationsShortPolling() {
      this.pegarNotificacoes();
      // if (!this.notifications_interval) {
      //   this.notifications_interval = setInterval(() => {
      //     this.pegarNotificacoes();
      //   }, this.shortPollingNotificationIntervalMS);
      // }
    },
    limpar() {
      this.frmPerfil = {
        email: "",
        nome: "",
        celular: "",
        habilitar2FA: false,
        canal2FA: "celular"
      };
      this.qr2fa = {
        svg: "",
        codigo: "",
        carregando: false,
        confirmando: false,
        confirmado: false
      };
    },

    abrir() {
      this.frmPerfil.email = this.currentUserPersonalInfo.login;
      this.frmPerfil.nome = this.currentUserPersonalInfo.nome;
      this.frmPerfil.celular = this.currentUserPersonalInfo.celular;

      if (this.checkSuperAdmin || this.isAccountAdmin) {
        this.frmPerfil.habilitar2FA = true;
      } else {
        this.frmPerfil.habilitar2FA =
          this.currentUserPersonalInfo.habilitado_2fa;
      }

      const usaApp = this.currentUserPersonalInfo.canal_2fa === "A";
      this.frmPerfil.canal2FA = usaApp ? "app" : "celular";
      this.qr2fa.confirmado = usaApp;
    },

    selecionarCanal(valor) {
      // Cards de método funcionam como radio: seleciona e dispara o fluxo.
      if (this.frmPerfil.canal2FA === valor) return;
      this.frmPerfil.canal2FA = valor;
      this.onCanalChange(valor);
    },

    onCanalChange(valor) {
      // Ao escolher o app (e ainda não confirmado), já gera o QR para escanear.
      if (valor === "app" && !this.qr2fa.confirmado) {
        this.gerarQrApp();
      }
    },

    trocarDispositivoApp() {
      // Permite recadastrar o app em um novo aparelho: volta a exibir o QR.
      this.qr2fa.confirmado = false;
      this.gerarQrApp();
    },

    gerarQrApp() {
      this.qr2fa.svg = "";
      this.qr2fa.codigo = "";
      this.qr2fa.carregando = true;

      ApiService.post("gerar-2fa-app")
        .then((resposta) => {
          this.qr2fa.svg = resposta.data.data.svg;
        })
        .catch(() => {
          Swal.fire({
            title: "MENSAGEM",
            text: "Não foi possível gerar o QR. Tente novamente.",
            icon: "error",
            heightAuto: false
          });
        })
        .finally(() => {
          this.qr2fa.carregando = false;
        });
    },

    confirmarApp() {
      this.qr2fa.confirmando = true;

      ApiService.post("confirmar-2fa-app", { codigo: this.qr2fa.codigo })
        .then(() => {
          this.qr2fa.confirmado = true;

          const usuario = { ...this.currentUserPersonalInfo };
          usuario.habilitado_2fa = true;
          usuario.canal_2fa = "A";
          this.$store.dispatch(UPDATE_PERSONAL_INFO, usuario);

          Swal.fire({
            title: "MENSAGEM",
            text: "Aplicativo autenticador ativado com sucesso!",
            icon: "success",
            heightAuto: false
          });
        })
        .catch(() => {
          Swal.fire({
            title: "MENSAGEM",
            text: "O código informado é inválido, tente novamente.",
            icon: "error",
            heightAuto: false
          });
        })
        .finally(() => {
          this.qr2fa.confirmando = false;
        });
    },

    validacao() {
      const frmPerfil = this.$refs["frmPerfil"];
      Inputmask().mask(frmPerfil.querySelectorAll("input"));

      this.fv = formValidation(frmPerfil, {
        fields: {
          nome: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          },
          celular: {
            validators: {
              notEmpty: {
                message: "Campo obrigatório."
              },
              blank: {}
            }
          }
        },
        plugins: {
          trigger: new Trigger(),
          submitButton: new SubmitButton(),
          bootstrap: new Bootstrap()
        }
      });
    },

    salvar(e) {
      e.preventDefault();

      this.fv.validate().then((status) => {
        if (status == "Valid") {
          ApiService.post("atualizar-perfil", this.frmPerfil)
            .then((resposta) => {
              const usuario = { ...this.currentUserPersonalInfo };
              usuario.habilitado_2fa = this.frmPerfil.habilitar2FA;
              // O canal por app só é ativado após confirmar o código (confirmarApp).
              // Aqui refletimos o desligamento ou a volta para o canal por celular.
              if (!this.frmPerfil.habilitar2FA) {
                usuario.canal_2fa = "T";
              } else if (this.frmPerfil.canal2FA === "celular") {
                usuario.canal_2fa = "T";
              }
              this.$store.dispatch(UPDATE_PERSONAL_INFO, usuario);

              Swal.fire({
                title: "MENSAGEM",
                text: "Perfil atualizado com sucesso!",
                icon: "success",
                heightAuto: false
              });
            })
            .catch(() => {
              for (const error in this.validatorErrors) {
                this.fv
                  .updateValidatorOption(
                    error,
                    "blank",
                    "message",
                    this.validatorErrors[error]
                  )
                  .updateFieldStatus(error, "Invalid", "blank");
              }
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.notification-bell-container {
  position: relative;

  .notification-bell-ball {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.3s ease;
  }
  i {
    font-size: 1.5rem !important;

    @keyframes bellshake {
      0% {
        transform: rotate(0);
      }
      15% {
        transform: rotate(5deg);
      }
      30% {
        transform: rotate(-5deg);
      }
      45% {
        transform: rotate(4deg);
      }
      60% {
        transform: rotate(-4deg);
      }
      75% {
        transform: rotate(2deg);
      }
      85% {
        transform: rotate(-2deg);
      }
      92% {
        transform: rotate(1deg);
      }
      100% {
        transform: rotate(0);
      }
    }

    &.notification-unread {
      animation: bellshake 0.8s ease-in-out;
      animation-iteration-count: infinite;
    }
  }

  .new-notification-news-ball {
    position: absolute;
    bottom: 10px;
    left: 10px;
    width: 15px;
    height: 15px;
    background: #ff0000;
    border-radius: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: bold;
  }
}

.notification-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 998 !important;
}
.notification-body-container {
  position: absolute;
  top: 120%;
  right: 0;
  width: 300px;
  height: 400px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  text-align: left;

  display: block;
  overflow-y: auto;

  .notification-body-item {
    padding: 14px;
    cursor: pointer;
    border-bottom: 0.8px solid #e1e1e1 !important;
    position: relative;
    transition: all 0.2s ease;
    &:hover {
      background: rgb(223, 223, 223) !important;
    }
    .unread-notification-ball {
      position: absolute;
      bottom: 50%;
      right: 12px;
      transform: translateY(50%);
      width: 10px;
      height: 10px;
      background: #ffa800;
      border-radius: 100%;
    }
    .notification-body-item-title {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 5px;
      color: #3f4254;
    }
    .notification-body-item-description {
      font-size: 1rem;
      margin-bottom: 5px;
      color: #3f4254;
    }
    .notification-body-item-date {
      font-size: 0.8rem;
      color: #999;
    }
  }
}
.save-btn {
  background-color: #39a567;
  color: #fff;
  margin-bottom: 10px;
}

.save-btn:hover {
  background-color: #2e8b57;
}

.icon-background {
  background-color: #ff7f00 !important;
  color: white !important;
}

.side-panel-btn {
  border-radius: 10px;
  background-color: #472282 !important;
  color: white;
  height: 39.06px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.side-panel-btn:hover {
  background-color: #3b1d6b !important;
  color: white !important;
}

.side-panel-btn-fail {
  border-radius: 10px;
  background-color: #ff0000;
  color: white;
  height: 39.06px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.side-panel-btn-fail:hover {
  background-color: #ec0404 !important;
  color: white;
}
</style>
